export { default as PhoneFrame } from './PhoneFrame';
export type { PhoneFrameProps } from './PhoneFrame';
